"use client";

import { ArrowRight } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
const steps = [{
  index: "01",
  name: "Request a Quote",
  description: "Start by calling or submitting the quote form with a few details about your bathroom remodel in Lakeland, FL, including what you want updated, your timeline, and your project goals.",
  linkLabel: "Request a Free Quote"
}, {
  index: "02",
  name: "Review Project Details",
  description: "After you request a quote, you can review your project details, bathroom layout, update options, materials, and next steps with a local bathroom remodel professional.",
  linkLabel: "View Bathroom Remodel Services"
}, {
  index: "03",
  name: "Review Quote Details",
  description: "Review quote details for your bathroom remodel, including the project scope, materials, timeline, and next steps. Exact details can vary based on your home, project size, and the local remodeling business.",
  linkLabel: "Request a Free Quote"
}, {
  index: "04",
  name: "Schedule Next Steps",
  description: "After reviewing the quote, you can discuss scheduling, project expectations, and next steps for your bathroom remodel.",
  linkLabel: "Request a Free Quote"
}];
function StepRow({
  step,
  i
}: {
  step: (typeof steps)[number];
  i: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  return <div data-index={i} ref={ref} className="transition-all ease-out" style={{
    opacity: isVisible ? 1 : 0,
    transform: isVisible ? "translateY(0)" : "translateY(24px)",
    transitionDuration: "800ms",
    transitionDelay: `${i * 120}ms`,
    transitionTimingFunction: "cubic-bezier(0.16, 1, 0.3, 1)"
  }}>
      <div className="font-mono text-sm font-medium text-primary tracking-[0.14em]">
        {step.index}
      </div>
      <div className="mt-4 h-px w-full bg-border" />
      <h3 className="mt-8 font-default text-2xl font-medium text-foreground tracking-tight">
        {step.name}
      </h3>
      <p className="mt-5 max-w-[540px] font-default text-base font-normal leading-relaxed text-primary">
        {step.description}
      </p>
      <Link to="#" className="group/link mt-8 inline-flex items-center gap-2 font-default text-sm font-medium text-primary" style={{
      textUnderlineOffset: "4px",
      textDecorationLine: "underline",
      textDecorationThickness: "1px",
      transition: "text-underline-offset 200ms ease-out"
    }} onMouseEnter={e => {
      (e.currentTarget as HTMLElement).style.textUnderlineOffset = "6px";
    }} onMouseLeave={e => {
      (e.currentTarget as HTMLElement).style.textUnderlineOffset = "4px";
    }}>
        
        
      </Link>
    </div>;
}
export default function QuoteProcess() {
  const {
    ref: introRef,
    isVisible: introVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  return <section data-section-id="15100" id="how-the-bathroom-remodel-quote-process-works" className="text-foreground py-32 md:py-44 bg-secondary">
      <div className="mx-auto w-full max-w-[1440px] px-6 md:px-22">
        <div className="grid grid-cols-1 gap-16 !bg-transparent md:grid-cols-12 md:gap-12">
          {}
          <div className="md:col-span-4">
            <div ref={introRef} className="md:sticky md:top-32 transition-all ease-out" style={{
            opacity: introVisible ? 1 : 0,
            transform: introVisible ? "translateY(0)" : "translateY(24px)",
            transitionDuration: "800ms",
            transitionTimingFunction: "cubic-bezier(0.16, 1, 0.3, 1)"
          }}>
              <div className="font-mono text-xs font-medium uppercase tracking-[0.14em] text-primary">BATHROOM REMODEL QUOTE PROCESS</div>

              <h2 className="mt-8 font-default text-[clamp(2.25rem,4.4vw,4.25rem)] font-normal text-foreground leading-[1.05] tracking-[-0.02em]">How to Request a Bathroom Remodel Quote</h2>

              <p className="mt-8 max-w-[320px] font-default text-lg font-light leading-[1.55] tracking-[-0.005em] text-primary">A simple way to request a bathroom remodel quote in Lakeland, FL and review next steps for your project.</p>
            </div>
          </div>

          {}
          <div className="md:col-span-8">
            <div className="flex flex-col gap-20">
              {steps.map((step, i) => <StepRow key={step.index} step={step} i={i} />)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}